/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { OptionListOptions } from '../services/workflow.service';

@Component({
  selector: 'xacc-select',
  templateUrl: './xacc-select.component.html',
  styleUrls: ['./xacc-select.component.less'],
  host: {
    '(document:submit)': 'onSubmit()',
  },
  standalone: false,
})
export class XaccSelectComponent implements OnInit {
  @Input() id: string;
  @Input() label: string;
  @Input() inlineLabel: string;
  @Input() list: OptionListOptions[] = [];
  @Input() selectedItem: any;
  @Input() property: string;
  @Input() localize: string;
  @Input() type: string;
  @Input() error: string;
  @Input() orderby: string;
  @Input() dir = 'asc';
  @Input() required: boolean;
  @Input() isMfd: boolean;
  @Input() isInputOnly: boolean;

  @Output() selectedItemChange = new EventEmitter<any>();
  @Output() change = new EventEmitter<any>();
  @Output() validation = new EventEmitter<boolean>();

  isSubmitted = false;
  dropdownMinWidth = '';

  ngOnInit() {
    if (this.isInputOnly) {
      this.dropdownMinWidth = '98%';
    } else {
      this.dropdownMinWidth = '100%';
    }
  }

  selectItem(item: any) {
    this.selectedItem = item;
    this.selectedItemChange.emit(this.selectedItem);
    this.change.emit(this.selectedItem);
    this.validate(true);
  }

  getPropertyString(
    type: 'localize' | 'property',
    item?: OptionListOptions,
  ): string {
    if (item) {
      if (type === 'localize') {
        const translationString = item[this.localize as keyof typeof item];
        return translationString as string;
      } else if (type === 'property') {
        const translationString = item[this.property as keyof typeof item];
        return translationString as string;
      }
    } else if (type === 'localize') {
      const translationString =
        this.selectedItem?.[this.localize as keyof typeof this.selectedItem];
      return translationString as string;
    } else if (type === 'property') {
      const translationString =
        this.selectedItem?.[this.property as keyof typeof this.selectedItem];
      return translationString as string;
    }
    return '';
  }

  isErrorState() {
    return !this.selectedItem && this.required && this.isSubmitted;
  }

  onSubmit() {
    this.isSubmitted = true;
  }

  validate(changed: boolean) {
    this.validation.emit(changed);
  }
}
